import { useEffect } from "react";
import { PropTypes } from "prop-types";

import { replacePhoneNumbers } from "../../helpers";
import heroBg from "../assets/hero-bg.jpg";
import { useCompanyInfo } from "../hooks/useCompanyInfo";
import { Container } from "./Container";
import { FormScrollRestoration } from "./FormScrollRestoration";
import { Header } from "./Header";
import { LogoIcon } from "./icons/LogoIcon";
import { PhoneCallIcon } from "./icons/PhoneCallIcon";

export const RootLayout = ({ children }) => {
	const { phoneNumber } = useCompanyInfo();

	useEffect(() => {
		replacePhoneNumbers();
	}, [phoneNumber]);

	return (
		// translate="no": in-app browser translation (Google app / Chrome iOS)
		// rewraps React-owned text nodes, making React's commit-phase removeChild
		// throw NotFoundError and killing the wizard mid-funnel
		<div
			translate="no"
			className="tw:mx-auto tw:max-w-[1440px] tw:overflow-hidden"
		>
			<div className="tw:relative tw:flex tw:h-full tw:min-h-[1520px] tw:flex-col tw:overflow-hidden tw:md:min-h-[1292px]">
				<FormScrollRestoration />
				{/* Hero Image */}
				<div
					role="presentation"
					className="tw:absolute tw:top-0 tw:left-0 tw:h-full"
				>
					<img
						src={heroBg}
						aria-hidden
						className="tw:h-full tw:object-cover"
						alt="Background moving truck"
					/>
				</div>
				{/* Hero Image cover image */}
				<div className="tw:absolute tw:top-0 tw:left-0 tw:h-full tw:w-full tw:bg-[linear-gradient(180deg,#FFF_-41.14%,rgba(255,255,255,0.85)_35.15%,rgba(255,255,255,0.50)_43.68%,rgba(255,255,255,0.20)_51.27%,rgba(255,255,255,0.00)_59.61%)]" />
				{/* Header */}
				<Header />
				{children}
			</div>
			{/* Have Questions Section */}
			{phoneNumber ? (
				<section aria-label="Call for questions" className="tw:bg-[#4B5563]">
					<Container className="tw:py-8 tw:md:py-10">
						<div className="tw:flex tw:flex-col tw:items-center tw:justify-between tw:lg:flex-row">
							<div className="tw:flex tw:flex-col tw:items-center tw:lg:flex-row tw:lg:gap-1">
								<p className="tw:text-center tw:text-xl tw:leading-[1.75rem] tw:font-bold tw:tracking-[-0.4px] tw:text-white tw:md:text-2xl tw:md:leading-8 tw:md:tracking-[-0.48px]">
									Have Questions?
								</p>
								<p className="tw:text-center tw:text-xl tw:leading-[1.75rem] tw:font-bold tw:tracking-[-0.4px] tw:text-white tw:md:text-2xl tw:md:leading-8 tw:md:tracking-[-0.48px]">
									Get our Lowest Price. Call Now!
								</p>
							</div>
							<a
								// Invoca phone number replacement replaces this number anyways, but adding phone number in anyways to avoid dev confusion
								href={`tel:${phoneNumber}`}
								className="tw:mt-4 tw:flex tw:items-center tw:rounded-sm tw:outline-hidden tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50 tw:lg:mt-0"
							>
								<PhoneCallIcon className="tw:mr-2 tw:text-[28px] tw:text-white tw:md:mr-3 tw:md:text-[2rem]" />
								<span className="tw:hide-in-percy tw:flex tw:text-xl tw:leading-[1.75rem] tw:font-bold tw:tracking-[-0.4px] tw:text-white tw:md:text-2xl tw:md:leading-8 tw:md:tracking-[-0.48px]">
									{phoneNumber}
								</span>
							</a>
						</div>
					</Container>
				</section>
			) : null}

			{/* Footer */}
			<footer className="tw:relative tw:mx-auto tw:flex tw:w-full tw:max-w-[1440px] tw:overflow-hidden">
				<Container className="tw:flex tw:flex-col tw:py-4 tw:md:py-10">
					<LogoIcon
						className="tw:mx-auto tw:h-[38px] tw:w-[178px]"
						ariaLabel="BestRelocation logo"
					/>
					<p className="tw:mt-4 tw:text-center tw:text-xs tw:leading-6 tw:font-normal tw:text-pretty tw:text-[#646464] tw:md:leading-5">
						The information on our website is general in nature and is intended
						for informational purposes only; it is not legal, health, investment
						or tax advice. BestRelocation makes no representation as to the
						accuracy of the information provided and assumes no liability for
						any damages or loss arising from its use. We may receive advertising
						revenue from some partners. See our FAQs for more information. At
						BestRelocation, we take privacy seriously. Please refer to our
						privacy policy to learn more about how we keep you protected. You’re
						responsible for yourself, so please remember that your use of this
						site constitutes acceptance of our terms of use.
					</p>
				</Container>
			</footer>
		</div>
	);
};

RootLayout.propTypes = {
	children: PropTypes.node,
};
